export default __webpack_public_path__ + "src/images/packages/kumbu-kumbu-lodge/9dab68bf434b7707d8c4abbc49f56059-3.jpg";